export default __webpack_public_path__ + "static/media/A_Abelha.74c1ac07.mp3";